/* shani-cart-upsell (cart-upsell-2026-10): בלוק ההצעות בסל, במגירה וב-/cart.
   - מצב ב' (סל בסף ומעליו): אביזרים מ"אקססוריז" בלבד, בלי נעליים, בגדי ים, פריט עם מידת ביגוד ו"פריט ב-20 ₪", כל אחד עד 30% מהסל.
   - מצב א' (מתחת לסף): רק כש-data-mode-a="true". בלי המתג אין בלוק ואין שליפה.
   - אין סף, upsell_arm=off, או 0 מועמדים: אין בלוק. הקרוסלה הישנה נמחקה מהתבנית.
   - ההוספה נעשית כאן ולא ב-theme.js: המטפל של Halo (actionAddToCart) שולח רק id וכמות, ומאבד את properties[_source].
     הבדיקה נגד כפל (כמו shani-cart-guard.js) והבדיקה "נמכר" רצות לפני ההוספה.
   החלק הטהור (core) נבדק ב-Node: build/test/run-node.js. */
(function (root) {
  'use strict';

  /* ---------- core: בלי DOM ---------- */
  var WINDOW = 4000, SHARE_B = 0.30, MAX = 4;
  var ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
  var JEWEL = /(עגיל|שרשר|ענק|צמיד|טבעת|סיכ)/;
  var SHOE = /מידה\s*\d/;
  var SWIM = /(בגד ים|בגדי ים|בקיני|ביקיני)/;
  var TAIL = /\s*-\s*((?:XXS|XS|S|M|L|XL|XXL|OS)(?:\s*-\s*(?:XXS|XS|S|M|L|XL|XXL))?)\s*$/i;

  function cents(x) { var n = parseFloat(x); return isNaN(n) ? 0 : Math.round(n * 100); }

  /* שם לתצוגה בלי "- OS", והמידה שבסוף השם כטווח (S-M = S,M) */
  function sizeInfo(title) {
    var t = String(title || '').replace(/\s+/g, ' ').trim();
    var m = t.match(TAIL);
    if (!m) return { name: t, label: '', sizes: [] };
    var raw = m[1].toUpperCase().replace(/\s+/g, '');
    var base = t.slice(0, m.index).trim();
    if (raw === 'OS') return { name: base, label: '', sizes: [] };
    var parts = raw.split('-'), a = ORDER.indexOf(parts[0]), b = ORDER.indexOf(parts[parts.length - 1]);
    if (a < 0 || b < 0) return { name: t, label: '', sizes: [] };
    if (b < a) { var x = a; a = b; b = x; }
    return { name: base, label: raw, sizes: ORDER.slice(a, b + 1) };
  }

  function imgUrl(p) {
    var src = p.images && p.images[0] && p.images[0].src;
    if (!src) return '';
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=240';
  }

  /* מוצר מ-products.json לרשומה קטנה. אין וריאנט זמין: null */
  function compact(p) {
    var v = null;
    for (var i = 0; i < (p.variants || []).length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
    if (!v) return null;
    var si = sizeInfo(p.title);
    return {
      id: p.id, h: p.handle, n: si.name, sl: si.label, sz: si.sizes,
      pub: Date.parse(p.published_at || p.created_at) || 0,
      v: v.id, p: cents(v.price), c: v.compare_at_price ? cents(v.compare_at_price) : 0,
      img: imgUrl(p),
      shoe: SHOE.test(p.title), swim: SWIM.test(p.title), jew: JEWEL.test(p.title)
    };
  }

  function newest(a, b) { return (b.pub - a.pub) || (b.id - a.id); }

  /* סבב: מתוך 12 החדשים בשכבה, סדר אקראי לפי זרע של הגולשת. אותו זרע = אותו סדר, ולכן הבלוק לא קופץ בין רענונים.
     הזרע מתחלף כל 24 שעות (בדפדפן). בלי זרע: "הכי חדש" בלבד. מעבר ל-12 החדשים: לפי "הכי חדש", רק כגיבוי */
  var ROTATE = 12;
  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function rotate(list, seed) {
    var sorted = list.slice().sort(newest);
    if (!seed) return sorted;
    var head = sorted.slice(0, ROTATE), tail = sorted.slice(ROTATE);
    head.sort(function (a, b) { return (hash(seed + ':' + a.id) - hash(seed + ':' + b.id)) || newest(a, b); });
    return head.concat(tail);
  }

  /* s: {total, freeFrom, modeA, inCart{pid}, sizes{S}, gone{pid}, seed} · pools: {acc[], p20{id}, all[]|null}
     מחזיר {mode:'A'|'B'|null, gap, items[], needAll} */
  function pick(s, pools) {
    var none = { mode: null, gap: 0, items: [], needAll: false };
    if (!(s.freeFrom > 0) || !(s.total > 0)) return none;
    var inCart = s.inCart || {}, gone = s.gone || {}, p20 = pools.p20 || {}, sizes = s.sizes || {};
    function ok(p) { return p && !inCart[p.id] && !gone[p.id] && !p20[p.id] && !p.shoe && !p.swim; }
    var accSet = {};
    (pools.acc || []).forEach(function (p) { accSet[p.id] = 1; });
    var out = [], seen = {};
    function push(p) { if (p && !seen[p.id] && out.length < MAX) { seen[p.id] = 1; out.push(p); } }

    if (s.total >= s.freeFrom) {
      var cap = Math.floor(s.total * SHARE_B);
      var acc = (pools.acc || []).filter(function (p) { return ok(p) && !p.sz.length && p.p <= cap; });
      rotate(acc.filter(function (p) { return p.jew; }), s.seed).forEach(push);
      rotate(acc.filter(function (p) { return !p.jew; }), s.seed).forEach(push);
      return { mode: out.length ? 'B' : null, gap: 0, items: out, needAll: false };
    }

    if (!s.modeA) return none;
    if (!pools.all) return { mode: null, gap: 0, items: [], needAll: true };
    var gap = s.freeFrom - s.total, hi = gap + WINDOW;
    function inR(p) { return p.p >= gap && p.p <= hi; }
    function fits(p) { return p.sz.some(function (z) { return sizes[z]; }); }
    var byId = {}, pool = [];
    (pools.acc || []).concat(pools.all).forEach(function (p) { if (p && !byId[p.id]) { byId[p.id] = 1; pool.push(p); } });
    pool = pool.filter(function (p) { return ok(p) && inR(p); }).sort(newest);
    var accT = pool.filter(function (p) { return accSet[p.id] && !p.sz.length; });
    var cloT = pool.filter(function (p) { return p.sz.length && fits(p); });   /* ביגוד, או אביזר עם מידה, במידה שכבר בסל */
    var othT = pool.filter(function (p) { return !accSet[p.id] && !p.sz.length; });
    /* ביגוד במידה שלא בסל: אף פעם */
    push(accT[0]); push(cloT[0]);
    accT.forEach(push); cloT.forEach(push); othT.forEach(push);
    return { mode: out.length ? 'A' : null, gap: gap, items: out, needAll: false };
  }

  var core = { sizeInfo: sizeInfo, compact: compact, pick: pick, cents: cents, rotate: rotate, WINDOW: WINDOW, SHARE_B: SHARE_B, MAX: MAX, ROTATE: ROTATE };
  if (typeof module !== 'undefined' && module.exports) { module.exports = core; }
  if (typeof document === 'undefined') return;

  /* ---------- דפדפן ---------- */
  if (root.__shaniCartUpsell) return;
  root.__shaniCartUpsell = core;

  var base = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
  var TTL = 600000, STALE = 60000, SKEL_AFTER = 150, GIVE_UP = 2500, ADDED_MS = 2000, SOLD_MS = 1800, NOTE_MS = 5000, LEAVE_MS = 240;
  var KEY = 'scu:v1', KEY_ALL = 'scu:v1:all', KEY_JA = 'scu:ja', KEY_ARM = 'scu_arm', KEY_SEED = 'scu_seed', DAY = 86400000;
  var mem = null, memAll = null, loading = null, loadingAll = null;
  var gone = {}, notes = {}, sels = {}, armSent = null;
  var reduce = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ssGet(k) { try { var v = sessionStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function now() { return Date.now(); }
  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      return r.json();
    });
  }
  /* כל העמודים של קולקציה (250 בעמוד, עד 4 עמודים) */
  function allPages(path) {
    var acc = [];
    function page(n) {
      return getJSON(base + path + (path.indexOf('?') >= 0 ? '&' : '?') + 'limit=250&page=' + n).then(function (j) {
        var ps = (j && j.products) || [];
        acc = acc.concat(ps);
        return (ps.length === 250 && n < 4) ? page(n + 1) : acc;
      });
    }
    return page(1);
  }
  function collPath(handle) { return 'collections/' + encodeURIComponent(handle) + '/products.json'; }

  function loadBase(cfg) {
    if (mem && now() - mem.t < TTL) return Promise.resolve(mem);
    var c = ssGet(KEY);
    if (c && now() - c.t < TTL && c.acc) { mem = c; return Promise.resolve(mem); }
    if (loading) return loading;
    loading = Promise.all([allPages(collPath(cfg.acc)), allPages(collPath(cfg.p20))]).then(function (r) {
      var p20 = {};
      r[1].forEach(function (p) { p20[p.id] = 1; });
      mem = { t: now(), acc: r[0].map(compact).filter(Boolean), p20: p20 };
      ssSet(KEY, mem);
      loading = null;
      return mem;
    }, function (e) { loading = null; throw e; });
    return loading;
  }
  /* מצב א' בלבד: 500 המוצרים החדשים בחנות (products.json מסודר מהחדש לישן) */
  function loadAll() {
    if (memAll && now() - memAll.t < TTL) return Promise.resolve(memAll);
    var c = ssGet(KEY_ALL);
    if (c && now() - c.t < TTL && c.all) { memAll = c; return Promise.resolve(memAll); }
    if (loadingAll) return loadingAll;
    loadingAll = Promise.all([1, 2].map(function (n) { return getJSON(base + 'products.json?limit=250&page=' + n); })).then(function (r) {
      var all = [];
      r.forEach(function (j) { all = all.concat(((j && j.products) || []).map(compact).filter(Boolean)); });
      memAll = { t: now(), all: all };
      ssSet(KEY_ALL, memAll);
      loadingAll = null;
      return memAll;
    }, function (e) { loadingAll = null; throw e; });
    return loadingAll;
  }

  /* ---------- upsell_arm: פעם אחת לגולשת, ונשמר כמאפיין סל כדי שיגיע להזמנה ---------- */
  function getArm(sec) {
    var a = null;
    try { a = localStorage.getItem(KEY_ARM); } catch (e) {}
    if (a !== 'on' && a !== 'off') {
      a = sec.getAttribute('data-arm');
      if (a !== 'on' && a !== 'off') a = Math.random() < 0.5 ? 'on' : 'off';
      try { localStorage.setItem(KEY_ARM, a); } catch (e) {}
    }
    return a;
  }
  function syncArm(sec, arm) {
    if (sec.getAttribute('data-arm') === arm || armSent === arm) return;
    armSent = arm;
    fetch(base + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { upsell_arm: arm } })
    }).then(function (r) { if (!r.ok) armSent = null; }, function () { armSent = null; });
  }

  /* זרע הסבב: לכל גולשת, ל-24 שעות. בלי localStorage: זרע לדף הנוכחי בלבד */
  var pageSeed = null;
  function getSeed() {
    var o = null;
    try { o = JSON.parse(localStorage.getItem(KEY_SEED) || 'null'); } catch (e) {}
    if (o && o.s && o.until > now()) return o.s;
    if (!pageSeed) pageSeed = Math.random().toString(36).slice(2, 10);
    try { localStorage.setItem(KEY_SEED, JSON.stringify({ s: pageSeed, until: now() + DAY })); } catch (e) {}
    return pageSeed;
  }

  /* ---------- קריאת המיכל ---------- */
  function readCfg(sec) {
    var map = {}, sizes = {}, inCart = {};
    (sec.getAttribute('data-in-cart') || '').split(',').forEach(function (id) { if (id) inCart[id] = 1; });
    (sec.getAttribute('data-sizes-map') || '').split(';').forEach(function (pair) {
      var kv = pair.split(':');
      if (kv.length === 2) map[kv[0]] = kv[1].split('.').filter(Boolean).map(function (z) { return z.toUpperCase(); });
    });
    Object.keys(inCart).forEach(function (id) { (map[id] || []).forEach(function (z) { sizes[z] = 1; }); });
    return {
      surface: sec.getAttribute('data-scu'),
      freeFrom: parseInt(sec.getAttribute('data-free-from'), 10) || 0,
      total: parseInt(sec.getAttribute('data-total'), 10) || 0,
      modeA: sec.getAttribute('data-mode-a') === 'true',
      inCart: inCart, sizes: sizes,
      acc: sec.getAttribute('data-acc') || 'אקססוריז',
      p20: sec.getAttribute('data-p20') || 'פריט-ב-20-בלבד'
    };
  }

  function hide(sec) {
    sec.hidden = true;
    sec.removeAttribute('aria-busy');
    var list = sec.querySelector('.scu-list');
    if (list) list.replaceChildren();
  }

  function justAdded() {
    var ja = ssGet(KEY_JA);
    return ja && ja.until > now() ? ja : null;
  }

  /* ---------- בניית הכרטיס (צמתים בלבד, שם המוצר ב-textContent) ---------- */
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function money(c, opt) {
    if (root.shaniMoneyNode) return root.shaniMoneyNode(c, opt);
    return el(opt && opt.was ? 's' : 'span', 'sp-m' + (opt && opt.was ? ' sp-was' : '') + (opt && opt.cls ? ' ' + opt.cls : ''), Math.round(c / 100) + ' ₪');
  }
  /* אותו סימון כמו snippets/shani-card-price */
  function priceNode(p) {
    var d = el('div', 'shc-price scu-price');
    if (p.c > p.p) {
      d.appendChild(el('span', 'visually-hidden', 'מחיר'));
      d.appendChild(money(p.p, { cls: 'sp-now sp-now--sale' }));
      d.appendChild(el('span', 'visually-hidden', 'במקום'));
      d.appendChild(money(p.c, { was: true }));
    } else {
      d.appendChild(money(p.p, { cls: 'sp-now' }));
    }
    return d;
  }
  var SVGNS = 'http://www.w3.org/2000/svg';
  function checkSvg() {
    var s = document.createElementNS(SVGNS, 'svg'); s.setAttribute('viewBox', '0 0 16 16'); s.setAttribute('aria-hidden', 'true');
    var pth = document.createElementNS(SVGNS, 'path'); pth.setAttribute('d', 'M3 8.5l3 3 7-7'); pth.setAttribute('fill', 'none'); pth.setAttribute('stroke', 'currentColor'); pth.setAttribute('stroke-width', '2');
    s.appendChild(pth); return s;
  }
  function setBtn(btn, state, name) {
    btn.replaceChildren();
    btn.classList.remove('is-added', 'is-sold');
    btn.removeAttribute('aria-busy');
    if (state === 'busy') {
      btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.setAttribute('aria-label', 'הוספה לסל');
      btn.appendChild(el('span', 'scu-spin'));
    } else if (state === 'added') {
      btn.disabled = true; btn.classList.add('is-added'); btn.setAttribute('aria-label', name + ' בסל');
      btn.appendChild(checkSvg()); btn.appendChild(document.createTextNode('בסל'));
    } else if (state === 'sold') {
      btn.disabled = true; btn.classList.add('is-sold'); btn.removeAttribute('aria-label');
      btn.textContent = 'נמכר';
    } else {
      btn.disabled = false; btn.setAttribute('aria-label', 'הוספת ' + name + ' לסל');
      btn.textContent = '+ הוסיפי';
    }
  }
  function card(p, mode, ja) {
    var li = el('li', 'scu-card');
    li.setAttribute('data-scu-card', '');
    li.setAttribute('data-product-id', p.id);
    var href = base + 'products/' + encodeURIComponent(p.h);
    var media = el('a', 'scu-media');
    media.href = href; media.tabIndex = -1; media.setAttribute('aria-hidden', 'true');
    if (p.img) {
      var img = el('img'); img.src = p.img; img.alt = ''; img.loading = 'lazy'; img.width = 120; img.height = 160;
      media.appendChild(img);
    }
    var body = el('div', 'scu-body');
    var name = el('a', 'scu-name');
    name.href = href;
    name.appendChild(document.createTextNode(p.n));
    if (mode === 'A' && p.sl) { name.appendChild(document.createTextNode(' - ')); name.appendChild(el('b', null, p.sl)); }
    var fullName = p.n + (mode === 'A' && p.sl ? ' - ' + p.sl : '');
    var btn = el('button', 'scu-add');
    btn.type = 'button';
    btn.setAttribute('data-scu-add', '');
    btn.setAttribute('data-variant', p.v);
    btn.setAttribute('data-handle', p.h);
    btn.setAttribute('data-pid', p.id);
    btn.setAttribute('data-name', fullName);
    setBtn(btn, ja && String(ja.id) === String(p.id) ? 'added' : 'idle', fullName);
    var form = el('div', 'scu-form');
    form.appendChild(btn);
    body.appendChild(name);
    body.appendChild(priceNode(p));
    body.appendChild(form);
    li.appendChild(media);
    li.appendChild(body);
    return li;
  }
  function skeleton(sec, n) {
    var list = sec.querySelector('.scu-list');
    var title = sec.querySelector('.scu-title');
    if (!list) return;
    if (title) { title.textContent = ''; title.classList.remove('is-note'); }
    list.replaceChildren();
    for (var i = 0; i < n; i++) {
      var li = el('li', 'scu-card scu-skel'); li.setAttribute('aria-hidden', 'true');
      var m = el('span', 'scu-media'), b = el('div', 'scu-body');
      b.appendChild(el('span', 'scu-name', ' ')); b.appendChild(el('span', 'scu-price')); b.appendChild(el('span', 'scu-add', ' '));
      li.appendChild(m); li.appendChild(b); list.appendChild(li);
    }
    sec.setAttribute('aria-busy', 'true');
    sec.hidden = false;
  }

  function titleFor(sec, sel) {
    var t = sec.querySelector('.scu-title');
    if (!t) return;
    var note = notes[sec.getAttribute('data-scu')];
    t.replaceChildren();
    if (note && note.until > now()) {
      t.classList.add('is-note');
      t.textContent = note.text;
      return;
    }
    t.classList.remove('is-note');
    if (sel.mode === 'A') {
      /* X מעוגל למעלה, אף פעם לא 0 (כמו בסרגל) */
      t.appendChild(money(Math.max(1, Math.ceil(sel.gap / 100)) * 100));
      t.appendChild(document.createTextNode(' למשלוח חינם. אחד מאלה מספיק'));
    } else {
      t.textContent = 'אביזרים, והמשלוח נשאר חינם';
    }
  }

  function draw(sec, cfg, data, dataAll) {
    var surface = cfg.surface, ja = justAdded(), prev = sels[surface], sel;
    /* אחרי הוספה: אותה שורה נשארת 2 שניות עם "✓ בסל", ורק אז הבחירה מתחלפת (גם מעבר ממצב א' לב') */
    if (ja && prev && prev.items.some(function (p) { return String(p.id) === String(ja.id); })) {
      sel = prev;
      setTimeout(function () { leaveThenRender(sec, ja.id); }, Math.max(0, ja.until - now()));
    } else {
      sel = pick({ total: cfg.total, freeFrom: cfg.freeFrom, modeA: cfg.modeA, inCart: cfg.inCart, sizes: cfg.sizes, gone: gone, seed: getSeed() },
        { acc: data.acc, p20: data.p20, all: dataAll ? dataAll.all : null });
      if (ja) ja = null;
    }
    if (!sel.items.length) { sels[surface] = null; hide(sec); return; }
    sels[surface] = sel;
    titleFor(sec, sel);
    var list = sec.querySelector('.scu-list');
    list.replaceChildren();
    sel.items.forEach(function (p) { list.appendChild(card(p, sel.mode, ja)); });
    sec.classList.toggle('is-single', sel.items.length === 1);
    sec.removeAttribute('aria-busy');
    sec.hidden = false;
    list.scrollLeft = 0; /* אחרי שלד, WebKit השאיר את הכרטיס הראשון מחוץ למסך */
    navState(sec);
  }

  function leaveThenRender(sec, pid) {
    if (!sec.isConnected) return;
    var s = sec.getAttribute('data-scu');
    var c = sec.querySelector('[data-scu-card][data-product-id="' + pid + '"]');
    if (c && !reduce) { c.classList.add('is-leaving'); setTimeout(function () { sels[s] = null; render(sec); }, LEAVE_MS); }
    else { sels[s] = null; render(sec); }
  }

  /* ---------- רינדור מיכל ---------- */
  function render(sec) {
    if (!sec || !sec.isConnected) return;
    var cfg = readCfg(sec);
    /* סל ריק = אין בלוק. ב-/cart המיכל נשאר אחרי הסרת הפריט האחרון */
    if (!Object.keys(cfg.inCart).length || cfg.total <= 0) { hide(sec); return; }
    var arm = getArm(sec);
    syncArm(sec, arm);
    if (arm === 'off' || !(cfg.freeFrom > 0)) { hide(sec); return; }
    var under = cfg.total < cfg.freeFrom;
    if (under && !cfg.modeA) { hide(sec); return; }   /* בלי המתג: אין בלוק ואין שליפה */
    var done = false, gen = (sec.__scuGen = (sec.__scuGen || 0) + 1);
    var skelT = setTimeout(function () { if (!done && gen === sec.__scuGen) skeleton(sec, cfg.surface === 'page' ? 4 : 2); }, SKEL_AFTER);
    var giveT = setTimeout(function () { if (!done && gen === sec.__scuGen) { done = true; hide(sec); } }, GIVE_UP);
    loadBase(cfg).then(function (data) {
      if (under) return loadAll().then(function (all) { return [data, all]; });
      return [data, null];
    }).then(function (r) {
      clearTimeout(skelT); clearTimeout(giveT);
      if (done || gen !== sec.__scuGen) return;
      done = true;
      draw(sec, cfg, r[0], r[1]);
      if (now() - r[0].t > STALE) verifyShown(sec);
    }, function () {
      clearTimeout(skelT); clearTimeout(giveT);
      if (gen !== sec.__scuGen) return;
      done = true; hide(sec);   /* תקלה ברשת: אין בלוק, בלי הודעת שגיאה */
    });
  }

  /* פריט שנמכר בלי שלחצו עליו: יוצא בשקט (בפתיחת המגירה ובחזרה ללשונית, כשהנתונים בני יותר מדקה) */
  function productAvailable(handle, variantId) {
    return getJSON(base + 'products/' + encodeURIComponent(handle) + '.js').then(function (p) {
      return (p.variants || []).some(function (v) { return String(v.id) === String(variantId) && v.available; });
    }, function (e) { if (String(e && e.message) === '404') return false; throw e; });
  }
  function verifyShown(sec) {
    var btns = Array.prototype.slice.call(sec.querySelectorAll('[data-scu-add]:not(:disabled)'));
    if (!btns.length) return;
    Promise.all(btns.map(function (b) {
      return productAvailable(b.getAttribute('data-handle'), b.getAttribute('data-variant')).then(function (ok) { return ok ? null : b.getAttribute('data-pid'); }, function () { return null; });
    })).then(function (ids) {
      var any = false;
      ids.forEach(function (id) { if (id) { gone[id] = 1; any = true; } });
      if (any) { sels[sec.getAttribute('data-scu')] = null; render(sec); }
    });
  }
  function verifyAll() {
    if (!mem || now() - mem.t <= STALE) return;
    document.querySelectorAll('.scu[data-scu]:not([hidden])').forEach(verifyShown);
  }

  /* ---------- ההוספה ---------- */
  function live(sec, text) {
    var l = sec && sec.querySelector('[data-scu-live]');
    if (l) { l.textContent = ''; setTimeout(function () { l.textContent = text; }, 30); }
  }
  function refreshDrawer() {
    var wrap = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    var cartP = getJSON(base + 'cart.js');
    if (!wrap) return cartP;
    /* כמו halo.updateSidebarCart ב-theme.js (הפונקציה לא חשופה מחוץ ל-IIFE של התבנית). HTML מהחנות עצמה */
    return fetch(base + 'cart?view=ajax_side_cart', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.text(); }).then(function (html) {
      if (root.jQuery) root.jQuery(wrap).html(html);
      else wrap.replaceChildren(document.createRange().createContextualFragment(html));
      document.querySelectorAll('[data-free-shipping-wrapper]').forEach(function (w) { w.dispatchEvent(new Event('change', { bubbles: true })); });
      return cartP;
    }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
      return cart;
    });
  }
  function soldOut(sec, btn) {
    var surface = sec.getAttribute('data-scu'), pid = btn.getAttribute('data-pid'), name = btn.getAttribute('data-name');
    var c = btn.closest('[data-scu-card]');
    setBtn(btn, 'sold', name);
    if (c) c.classList.add('is-sold');
    gone[pid] = 1;
    notes[surface] = { text: 'מישהי קנתה את ' + name + '.', until: now() + NOTE_MS };
    var t = sec.querySelector('.scu-title');
    if (t) { t.classList.add('is-note'); t.textContent = notes[surface].text; }
    live(sec, notes[surface].text);
    setTimeout(function () { leaveThenRender(sec, pid); }, SOLD_MS);
    setTimeout(function () {
      var n = notes[surface];
      if (n && n.until <= now()) {
        notes[surface] = null;
        var s2 = document.querySelector('.scu[data-scu="' + surface + '"]');
        if (s2 && !s2.hidden && sels[surface]) titleFor(s2, sels[surface]);
      }
    }, NOTE_MS + 50);
  }
  function dropSilently(sec, btn) {
    gone[btn.getAttribute('data-pid')] = 1;
    leaveThenRender(sec, btn.getAttribute('data-pid'));
  }
  var busy = {};
  function onAdd(btn) {
    var sec = btn.closest('.scu[data-scu]');
    if (!sec || btn.disabled) return;
    var vid = btn.getAttribute('data-variant'), pid = btn.getAttribute('data-pid'), name = btn.getAttribute('data-name');
    var surface = sec.getAttribute('data-scu');
    if (busy[vid] && busy[vid] > now()) return;
    busy[vid] = now() + 8000;
    setBtn(btn, 'busy', name);
    function added() {
      busy[vid] = 0;
      ssSet(KEY_JA, { id: pid, until: now() + ADDED_MS });
      setBtn(btn, 'added', name);
      live(sec, name + ' בסל');
      if (surface === 'page') { setTimeout(function () { root.location.reload(); }, 600); return; }
      refreshDrawer().catch(function () { root.location.reload(); });
    }
    /* פריט יחיד: אם הוא כבר בסל (לשונית אחרת), לא מוסיפים שוב. אותה בדיקה כמו shani-cart-guard.js */
    getJSON(base + 'cart.js').then(function (c) {
      if ((c.items || []).some(function (it) { return String(it.variant_id) === String(vid); })) return 'in';
      return productAvailable(btn.getAttribute('data-handle'), vid).then(function (ok) { return ok ? 'go' : 'sold'; });
    }).then(function (st) {
      if (st === 'in') { added(); return; }
      if (st === 'sold') { busy[vid] = 0; soldOut(sec, btn); return; }
      return fetch(base + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1, properties: { _source: 'cart-upsell-' + surface } }] })
      }).then(function (r) {
        if (r.ok) { added(); return; }
        /* נכשל: נמכר בין הבדיקה להוספה = "נמכר". כל סיבה אחרת = הכרטיס יורד בשקט */
        busy[vid] = 0;
        return productAvailable(btn.getAttribute('data-handle'), vid).then(function (ok) {
          if (ok) dropSilently(sec, btn); else soldOut(sec, btn);
        }, function () { dropSilently(sec, btn); });
      });
    }).catch(function () { busy[vid] = 0; dropSilently(sec, btn); });
  }

  /* ---------- חיצים (מגירה, עכבר בלבד) ---------- */
  function navState(sec) {
    var list = sec.querySelector('.scu-list'), prev = sec.querySelector('[data-scu-prev]'), next = sec.querySelector('[data-scu-next]');
    if (!list || !prev || !next) return;
    var max = list.scrollWidth - list.clientWidth, pos = Math.abs(list.scrollLeft);
    prev.disabled = pos <= 1;
    next.disabled = pos >= max - 1;
  }
  function navStep(sec, dir) {
    var list = sec.querySelector('.scu-list'), c = list && list.querySelector('.scu-card');
    if (!c) return;
    var step = c.getBoundingClientRect().width + 16;
    var rtl = getComputedStyle(list).direction === 'rtl';
    list.scrollBy({ left: (rtl ? -1 : 1) * dir * step, behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ---------- חיווט ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var add = t.closest('[data-scu-add]');
    if (add) { e.preventDefault(); onAdd(add); return; }
    var nav = t.closest('[data-scu-prev],[data-scu-next]');
    if (nav) { e.preventDefault(); navStep(nav.closest('.scu'), nav.hasAttribute('data-scu-next') ? 1 : -1); }
  });
  document.addEventListener('scroll', function (e) {
    var l = e.target;
    if (l && l.classList && l.classList.contains('scu-list')) navState(l.closest('.scu'));
  }, true);

  function scan() {
    document.querySelectorAll('.scu[data-scu]').forEach(function (sec) {
      if (sec.__scuInit) return;
      sec.__scuInit = true;
      render(sec);
    });
  }
  /* המגירה: Halo מחליפה את כל ה-HTML בכל שינוי בסל, ולכן מיכל חדש = רינדור חדש */
  var drawer = document.getElementById('halo-cart-sidebar');
  if (drawer && root.MutationObserver) new MutationObserver(scan).observe(drawer, { childList: true, subtree: true });
  /* פתיחת המגירה */
  if (root.MutationObserver) new MutationObserver(function () {
    if (document.body.classList.contains('cart-sidebar-show')) verifyAll();
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') verifyAll(); });
  /* /cart: theme.js מחליף רק את .cart ואת הסיכום, והמיכל נשאר. מעדכנים ממנו את הסכום ואת מה שבסל */
  document.addEventListener('cart-update', function (e) {
    notes = {};
    var cart = e && e.detail;
    var sec = document.querySelector('.scu[data-scu="page"]');
    if (!sec || !cart || !cart.items) return;
    var ids = {};
    cart.items.forEach(function (it) { ids[it.product_id] = 1; });
    sec.setAttribute('data-total', cart.total_price);
    sec.setAttribute('data-in-cart', Object.keys(ids).join(','));
    render(sec);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})(typeof window !== 'undefined' ? window : this);
